import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import productSearchQuery from '~/graphql/productSearch.gql';
import { buildCategoryProductsQuery } from '~/helpers/extract-helper';

function fetchSearch(_x, _x2, _x3) {
  return _fetchSearch.apply(this, arguments);
}

function _fetchSearch() {
  _fetchSearch = _asyncToGenerator(function* (context, keyword, query) {
    var locale = context.state.i18n.currentLocale.iso;
    var {
      offset,
      limit,
      sortBy,
      orderBy,
      filterBy
    } = buildCategoryProductsQuery(query);
    var response = yield context.app.apolloProvider.defaultClient.query({
      query: productSearchQuery,
      variables: {
        variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
        locale,
        keyword,
        offset,
        limit,
        sortBy,
        orderBy,
        filterBy
      }
    });
    return response.data;
  });
  return _fetchSearch.apply(this, arguments);
}

export { fetchSearch as default };